import React from 'react'
import { graphql } from "gatsby"
import * as styles from "./WordList.css"
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import {
  Section,
} from "../ui"

export interface WordListProps {
  wordList: string
}

export default function WordList(props: WordListProps) {
  return (
    <Section className={styles.wordList}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{props.wordList}</ReactMarkdown>
    </Section>
  )
}

export const query = graphql`
  fragment WordListContent on WordList {
    wordList 
  }
`